import { type MessageDescriptor } from "react-intl";

import { messages } from "./messages.generated";

export const enum EventInsightMetric {
    LensFaceFound = "0",
    LensFaceLost = "1",
    LensObjectTracked = "2",
    LensObjectTracked_3D = "3",
    LensMarkerTracked = "4",
    LensTap = "5",
    LensMultiuserSessionShared = "6",
    LensMultiuserSessionJoined = "7",
}

export type Metrics = { [key in EventInsightMetric]: { isActive: boolean; label: MessageDescriptor } };

export const defaultMetrics: Readonly<Metrics> = {
    [EventInsightMetric.LensFaceFound]: { isActive: true, label: messages.faceFoundFilterLabel },
    [EventInsightMetric.LensFaceLost]: { isActive: true, label: messages.faceLostFilterLabel },
    [EventInsightMetric.LensObjectTracked]: { isActive: true, label: messages.objectTrackedFilterLabel },
    [EventInsightMetric.LensObjectTracked_3D]: { isActive: true, label: messages.objectTracked3dFilterLabel },
    [EventInsightMetric.LensMarkerTracked]: { isActive: true, label: messages.markerTrackedFilterLabel },
    [EventInsightMetric.LensTap]: { isActive: true, label: messages.tapFilterLabel },
    [EventInsightMetric.LensMultiuserSessionShared]: {
        isActive: true,
        label: messages.multiuserSessionSharedFilterLabel,
    },
    [EventInsightMetric.LensMultiuserSessionJoined]: {
        isActive: true,
        label: messages.multiuserSessionJoinedFilterLabel,
    },
};
